/* lua.js generated code 0.3.1 */

let CommonRewardPanel = xClass("CommonRewardPanel", BasePanel, cc.Layer)
CommonRewardPanelEvent = {
    ClickShareAndReward : "COMMONREWARDPANELEVENT.CLICKSHAREANDREWARD"
}
CommonRewardPanel.resource = [
    "font/berlinsansfb_30_bluestroke.fnt",
    "font/zzgftongxin_40_greenstroke.fnt",
    "font/zzgftongxin_70_greenstroke.fnt",
    "cocos/common_reward_panel.plist",
    "cocos/common_reward_panel_bottom_btn_green_start.csb",
    "cocos/common_reward_panel_starglow.csb",
]
CommonRewardPanel.show = function (title, btnText, info, finishCallback, lockTable, needShare, brforeRewardHttpCallable, onSuccess, shareData) {
    function success() {
        let panel = CommonRewardPanel.create(title, btnText, info, finishCallback, lockTable, needShare, brforeRewardHttpCallable, shareData)
        if (onSuccess) {
            onSuccess(panel)
        }else {
            panel.popup()
        }
    }
    preloadWithLoading(CommonRewardPanel.resource, success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))        
    })
}

// self.rewardAnimType
// 值为 1 的时候是默认的动画
// 值为 2 的时候直接飞到背包
CommonRewardPanel.prototype.ctor = function (title, btnText, info, finishCallback, lockTable, needShare, brforeRewardHttpCallable, shareData = {}) {
    let self = this
    self.needShare = needShare || false
    cc.Layer.prototype.ctor.call(self)
    self.lockTable = lockTable
    self.finishCallback = finishCallback
    self.brforeRewardHttpCallable = brforeRewardHttpCallable
    self.nodeExist = true
    self.shareText = shareData.shareText
    self.textId = shareData.textId
    self.shareBg = shareData.shareBg
    self.btnText = btnText || getText("common.reward.panel.reward.btn")
    self.rewardAnimType = 1
    self.dstPos = null
    self.iconPath = null
    title = title || " "
    self.init(title, info)
}
CommonRewardPanel.prototype.init = function (title, info) {
    let self = this
    BasePanel.prototype.init.call(self)
    if (self.needShare) {
        self.close = cc.Sprite.createWithSpriteFrameName("uilibrary/offbottom_light_x_normal.png")
        UIButton.create(self.close, true)
        self.addChild(self.close, 500)
        self.close.setPosition(cc.winSize.width / 2 - 100, -900)
    }
    FrameLoader.loadImageWithPlist("cocos/common_reward_panel.plist")
    self.setContentSize(cc.size(cc.Director.getInstance().getVisibleSize()))
   //self.setScale(self.getReferenceScale())
    self.center()
    let vSize = cc.Director.getInstance().getVisibleSize()
    let mask = UIButton.create(cc.LayerColor.create(), true)
    mask.setContentSize(cc.size(vSize.width / self.getScale(), vSize.height / self.getScale()))
    mask.setPosition(cc.p(-self.getPositionX() / self.getScale(), -self.getPositionY() / self.getScale()))
    mask.setOpacity(0)
    self.addChild(mask, 100)
    let rewards = info || table()
    rewards = $arrayToTable(rewards);
    let countPerRow = 4
    if ($len(rewards) >= 5 && $len(rewards) <= 6) {
        countPerRow = 3
    }
    let margin = 30
    let posBase = cc.p(0, -1300 * cc.winSize.height / 1280)
    let lineCount = Math.ceil($len(rewards) / countPerRow)
    let totalHeight = lineCount * 100 + (lineCount - 1) * margin
    let [sprites, numTexts] = [table(), table()]
    for (let i = 1, v = rewards[1]; v; i++, v = rewards[i]) {
        let sprite = v["itemSpUrl"] == null? UIItemBuilder.createPropIcon(v.itemId): cc.Sprite.create(v.itemSpUrl)
        sprite.setScale(105 / sprite.getContentSize().width)
        sprite.setVisible(false)
        let lineCount = Math.min($len(rewards) - Math.floor((i - 1) / countPerRow) * countPerRow, countPerRow)
        let lineWidth = lineCount * sprite.getContentSize().width * sprite.getScale() + (lineCount - 1) * margin
        let idxInLine = (i - 1) % countPerRow + 1
        let lineIdx = Math.floor((i - 1) / countPerRow) + 1
        let text = ccui.TextBMFont.create("x" + tostring(v.num), "font/berlinsansfb_30_bluestroke.fnt")
        text.getVirtualRenderer().setAdditionalKerning(-6)
        text.setName("num")
        text.setScale(sprite.getContentSize().height / 2 / text.getContentSize().height * 4 / 5)
        text.setAnchorPoint(cc.p(0.5, 1))
        let size = sprite.getContentSize()
        text.setPosition(cc.p(size.width, size.height / 2))
        sprite.addChild(text, 10)
        sprite.setPosition(cc.p(posBase.x - lineWidth / 2 + (idxInLine - 1) * margin + (idxInLine - 0.5) * sprite.getContentSize().width * sprite.getScale(), posBase.y + totalHeight / 2 - (lineIdx - 1) * margin - (lineIdx - 0.5) * sprite.getContentSize().height * sprite.getScale()))
        self.addChild(sprite, 120)
        sprite.itemId = v.itemId
        sprite.num = v.num
        sprite.itemSpUrl = v["itemSpUrl"]
        table.insert(sprites, sprite)
    }
    let $st24 = title.split(unicode_split_reg)
    let charTable = $table($st24)
    let [spriteTable, totalWidth] = [table(), 0]
    for (let i = 1, v = charTable[1]; v; i++, v = charTable[i]) {
        let text = cc.LabelBMFont.create(v, "font/zzgftongxin_70_greenstroke.fnt")
        text.setColor(cc.c3b(255, 242, 130))
        totalWidth = totalWidth + text.getContentSize().width
        self.addChild(text, 110)
        table.insert(spriteTable, text)
    }
    let widthAdd = 0
    for (let i = 1, v = spriteTable[1]; v; i++, v = spriteTable[i]) {
        v.setPosition(-totalWidth / 2 + widthAdd + v.getContentSize().width / 2, totalHeight / 2 - 1100)
        widthAdd = widthAdd + v.getContentSize().width
        v.setVisible(false)
    }
    let button = UIGLabelButton.create(cc.CSLoader.createNode("cocos/common_reward_panel_bottom_btn_green_start.csb"))
    button.setString(self.btnText)
    if (self.needShare) {
        // button.setString(getText("mark.panel.reward.share.btn"))
        button.setString(getText("common.reward.panel.reward.btn"))
    }
    button.setCascadeOpacityEnabled(true)
    button.setVisible(false)
    button.setName("button")
    button.setPosition(0, -totalHeight / 2 + posBase.y - 150)
    self.addChild(button, 130)
    for (let i = 1, v = spriteTable[1]; v; i++, v = spriteTable[i]) {
        let recPos = cc.p(v.getPosition())
        let recScale = v.getScale()
        v.setPosition(cc.p(recPos.x * 0.5, recPos.y - 190))
        v.setScale(0.5)
        v.runAction(cc.Sequence.create(cc.DelayTime.create((i - 1) * 0.03), cc.ToggleVisibility.create(), cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.23, cc.p(recPos.x, recPos.y)), cc.ScaleTo.create(0.23, recScale))), cc.CallFunc.create(function () {
            if (i === 1) {
                mask.runAction(cc.FadeTo.create(0.26, 165))
                let [numTable, glowTable] = [table(), table()]
                let counter = $len(sprites) + 1
                function onAnimFinish() {
                    counter = counter - 1
                    if (counter <= 0) {
                        self.gettingReward(mask, button, spriteTable, sprites, numTable, glowTable)
                    }
                }
                for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
                    let recPos = cc.p(v.getPosition())
                    let midPos1 = cc.pMul(cc.pSub(recPos, cc.p(recPos.x * 0.5, recPos.y - 100)), 1.17)
                    let midPos2 = cc.pSub(cc.pMul(cc.pSub(recPos, cc.p(recPos.x * 0.5, recPos.y - 100)), 0.85), midPos1)
                    let recScale = v.getScale()
                    v.setPosition(cc.p(recPos.x * 0.5, recPos.y - 100))
                    v.setScale(0.5)
                    v.runAction(cc.Sequence.create(cc.DelayTime.create((i - 1) * 0.03), cc.ToggleVisibility.create(), cc.EaseSineOut.create(cc.Spawn.create(cc.MoveBy.create(0.25, midPos1), cc.ScaleTo.create(0.25, recScale * 1.17))), cc.EaseSineIn.create(cc.Spawn.create(cc.MoveBy.create(0.33, midPos2), cc.ScaleTo.create(0.33, 0.85))), cc.Spawn.create(cc.MoveTo.create(0.125, recPos), cc.ScaleTo.create(0.125, recScale)), cc.CallFunc.create(function () {
                        let num = v.getChildByName("num")
                        if (num) {
                            num.retain()
                            num.removeFromParent(true)
                            num.setScale(v.getScale() * num.getScale())
                            let size = v.getContentSize()
                            num.setPosition(cc.p(v.getPositionX() + v.getContentSize().width * v.getScaleX() / 2, v.getPositionY()))
                            self.addChild(num, 135)
                            num.release()
                            table.insert(numTable, num)
                        }
                        let glow = self.rewardItemGlowAnim()
                        glow.setPosition(cc.p(v.getPosition()))
                        glow.setScale(0)
                        self.addChild(glow, 115)
                        glow.runAction(cc.ScaleTo.create(0.25, 0.9))
                        table.insert(glowTable, glow)
                    }), cc.DelayTime.create(0.26), cc.RotateTo.create(0.125, 15), cc.RotateTo.create(0.125, -15), cc.RotateTo.create(0.08, 15), cc.RotateTo.create(0.08, -15), cc.RotateTo.create(0.08, 0), cc.CallFunc.create(onAnimFinish)))
                }
                button.setOpacity(0)
                button.setPositionY(button.getPositionY() - 100)
                button.runAction(cc.Sequence.create(cc.Spawn.create(cc.ToggleVisibility.create(), cc.EaseBackOut.create(cc.MoveBy.create(0.33, cc.p(0, 100))), cc.FadeIn.create(0.33)), cc.CallFunc.create(function () {
                    onAnimFinish()
                    PushBounceIdleBubbleAnim.create(button)
                })))
            }
        }), cc.Spawn.create(cc.MoveTo.create(0.166, recPos), cc.ScaleTo.create(0.166, recScale))))
    }
}
CommonRewardPanel.prototype.onEnter = function() {
    BasePanel.prototype.onEnter.call(this)
    if (isWechatGameEnv()) {
        this.close && this.close.setPosition(100 - cc.winSize.width / 2, -900)
    }
}
CommonRewardPanel.prototype.rewardItemGlowAnim = function () {
    let self = this
    let glow = cc.CSLoader.createNode("cocos/common_reward_panel_starglow.csb")
    let sprite1 = glow.getChildByName("glow1")
    sprite1.runAction(cc.RepeatForever.create(cc.RotateBy.create(1, 50)))
    let sprite2 = glow.getChildByName("glow2")
    sprite2.runAction(cc.RepeatForever.create(cc.RotateBy.create(1, -50)))
    let sprite3 = glow.getChildByName("glow3")
    sprite3.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.ScaleBy.create(25 / 30, 80 / 96), cc.ScaleBy.create(25 / 30, 96 / 80))))
    let sprite4 = glow.getChildByName("glow4")
    sprite4.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.ScaleBy.create(20 / 30, 96 / 80), cc.DelayTime.create(58 / 30), cc.ScaleBy.create(23 / 30, 80 / 96))))
    let nextAngle = math.random() * 160 + 10
    function genNewStar(star) {
        star.stopAllActions()
        star.setOpacity(255)
        star.setPosition(cc.p(0, 0))
        star.runAction(cc.Sequence.create(cc.Spawn.create(cc.RotateBy.create(1.6, math.random() * 40 + 20), cc.FadeOut.create(1.6), cc.MoveTo.create(1.6, cc.p(Math.cos(nextAngle * Math.PI / 180) * 75, Math.sin(nextAngle * Math.PI / 180) * 75))), cc.CallFunc.create(function () {
            genNewStar(star)
        })))
        nextAngle = nextAngle + math.random() * 160 + 10
    }
    for (let i = 1; i <= 18; i += 1) {
        let star = glow.getChildByName("star" + tostring(i))
        star.setPosition(cc.p(0, 0))
        if (star) {
            star.runAction(cc.Sequence.create(cc.DelayTime.create(1.6 / 18 * (i - 1)), cc.CallFunc.create(function () {
                genNewStar(star)
            })))
        } else {
            break
        }
    }
    return glow
}
CommonRewardPanel.prototype.gettingReward = function (mask, button, spriteTable, sprites, numTable, glowTable) {
    let self = this
    let proced = false
    function shareSuccessCallback(rewards, lockTable) {
        if (lockTable) {
            self.lockTable = lockTable
        }
        button.removeEventListener(handler)
        if (proced) {
            return 
        }
        proced = true
        mask.runAction(cc.Sequence.create(cc.FadeOut.create(0.33), cc.CallFunc.create(function () {
            mask.removeFromParent(true)
        })))
        for (let i = 1, v = spriteTable[1]; v; i++, v = spriteTable[i]) {
            let recPos = cc.p(v.getPosition())
            let recScale = v.getScale()
            v.runAction(cc.Sequence.create(cc.Spawn.create(cc.MoveTo.create(0.33, cc.p(recPos.x * 0.6, recPos.y)), cc.FadeOut.create(0.33)), cc.CallFunc.create(function () {
                v.removeFromParent(true)
            })))
        }
        let rewardItems = table()
        for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
            if (rewards) {
                let find = false
                for (let j = 1, u = rewards[1]; u; j++, u = rewards[j]) {
                    if (v.itemId == u.itemId) {
                        v.num = u.num
                        numTable[i].setString("x" + u.num)
                        find = true
                        break
                    }
                }
                if (!find) {
                    for (let j = 1, u = lockTable[1]; u; j++, u = lockTable[j]) {
                        if (v.itemId == u.itemId) {
                            v.num = u.num
                            numTable[i].setString("x" + u.num)
                            find = true
                            break
                        }
                    }
                }
            }
            table.insert(rewardItems, table(
                [1, "itemId", v.itemId],
                [1, "num", v.num],
                [1, "icon", v],
                [1, "itemSpUrl", v["itemSpUrl"]],
            ))
        }
        if ($len(rewardItems) > 0) {
            let interval = rewards ? 2 : 0.15
            self.rewardItemAnims(rewardItems, function () {
                // if (self.finishCallback) {
                //     self.finishCallback()
                // }
                if (self.nodeExist) {
                    self.onClose(self.finishCallback)
                }
            })
        }
        for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
            v.removeFromParent(true)
        }
        for (let i = 1, v = numTable[1]; v; i++, v = numTable[i]) {
            v.removeFromParent(true)
        }
        for (let i = 1, v = glowTable[1]; v; i++, v = glowTable[i]) {
            v.runAction(cc.Sequence.create(cc.FadeOut.create(0.15), cc.CallFunc.create(function () {
                v.removeFromParent(true)
            })))
        }
        let scale = button.getScaleX()
        button.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.2, 0.4 * scale), cc.FadeOut.create(0.2)), cc.CallFunc.create(function () {
            button.removeFromParent(true)
        })))
    }
    function shareAfterCallback(errCode, msg, data) {
        function onError() {
            self.onClose(self.finishCallback)
        }
        if (self.brforeRewardHttpCallable) {
            self.brforeRewardHttpCallable(shareSuccessCallback, onError, {
                errCode: errCode,
                msg: msg,
                data: data
            })
        }else {
            shareSuccessCallback()
        }
    }
    function callback() {
        self.dispatchEvent({name: CommonRewardPanelEvent.ClickShareAndReward})
        if (self.needShare) {
            data = {
                title: self.shareText,
                textId: self.textId,
                bg: self.shareBg
            }
            GameProxy.getInstance().shareLinkJustCallback(shareAfterCallback, shareAfterCallback, shareAfterCallback, data)
        }else {
            shareAfterCallback()
        }
    }
    let [_, handler] = button.on(UIButtonEvent.Click, callback)
    if (self.close) {
        self.close.on(UIButtonEvent.Click, shareAfterCallback)
    }
}
CommonRewardPanel.prototype.setRewardAnimToBag = function () {
    this.setRewardAnimType(2)
    let homeScene = require("clover/scene/HomeScene").getInstance()
    if (homeScene.btnLayer && homeScene.btnLayer.ChestBtn) {
        this.dstPos = homeScene.btnLayer.ChestBtn.parent.convertToWorldSpace(homeScene.btnLayer.ChestBtn.getPosition())
        this.iconPath = "homeScene/chest_icon.png"
    }
}
CommonRewardPanel.prototype.setRewardAnimType = function (type) {
    let self = this
    self.rewardAnimType = type
}
CommonRewardPanel.prototype.rewardItemAnims = function (items, finishCallback, interval) {
    let self = this
    let flyItemOps = table()
    let counter = 0
    function onAnimFinish() {
        counter = counter - 1
        if (counter <= 0) {
            if (finishCallback) {
                finishCallback()
            }
        }
    }
    function onCoinAnimFinish() {
        // require("clover/scene/HomeScene").getInstance().highlightInfoBanner(true)
        onAnimFinish()
    }
    for (let i = 1, v = items[1]; v; i++, v = items[i]) {
        let parent = v.icon.getParent()
        let pos = parent.convertToWorldSpace(cc.p(v.icon.getPosition()))
        if (v.itemId === GamePropIds.kEnergyInf_1Hour) {
            counter = counter + 1
            HomeSceneAnimation.playInfiniteEnergyAnim(pos, onAnimFinish)
        } else {
            table.insert(flyItemOps, table(
                [1, "itemId", v.itemId],
                [1, "num", v.num],
                [1, "pos", pos],
                [1, "itemSpUrl", v["itemSpUrl"]],
            ))
        }
    }
    if (type(self.lockTable) === "table") {
        let HomeScene = require("clover/scene/HomeScene")
        let infoBanner = HomeScene.getInstance().infoBanner
        infoBanner.releaseCoin(self.lockTable.coin || 0)
        infoBanner.releaseCash(self.lockTable.cash || 0)
    }
    interval = interval ? interval : 0.15
    if ($len(flyItemOps) > 0) {
        counter = counter + 1
        if (self.rewardAnimType === 2) {
            PropBagAnimation.addItemsToBag(flyItemOps, onAnimFinish, 0.15, this.dstPos, this.iconPath)
        }else {
             HomeSceneAnimation.playGetPropAnimation(flyItemOps, onAnimFinish, 0.15)
        }
    }
}

CommonRewardPanel.prototype.popup = function () {
    let self = this
    PopoutManager.getInstance().add(self, false, false)
    self.onEnterAnimFinish()
    return self
}
CommonRewardPanel.prototype.remove = function (cleanup, callback) {
    let self = this
    cc.log("CommonRewardPanel:remove")
    self.onExitAnimStart()
    PopoutManager.getInstance().remove(self, true)
    setTimeout(() => {
        callback && callback()
    }, 0);
}
CommonRewardPanel.prototype.onCleanup = function () {
    ResManager.release(CommonRewardPanel.resource)
}
CommonRewardPanel.prototype.onKeyBackClicked = function () { }
module.exports = [CommonRewardPanel, CommonRewardPanelEvent]
